const firebaseConfig = {
    apiKey: "AIzaSyDxEFTmfxZFrZC8asXywlKAcIbvf050GF0",
    authDomain: "counseling-21.firebaseapp.com",
    projectId: "counseling-21",
    storageBucket: "counseling-21.appspot.com",
    messagingSenderId: "822594251810",
    appId: "1:822594251810:web:35daf8f2bf9be7cc7a2e7b"
};
export default firebaseConfig